// extracted by mini-css-extract-plugin
module.exports = {"items":"list_items__BuA1e","series":"list_series___Gjjo","grid":"list_grid__oc0lN","letter":"list_letter__JRvih","item":"list_item__fjWSn"};